<template>
  <div>
    <TopHeader code="live" />

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'Live' }" class="item"
                >直播</router-link
              >
              <router-link to="" class="item">直播详情</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-17">
            <section class="uc-ResourcesInfo uc-mr10">
              <div class="left">
                <div class="img-box">
                  <el-image :src="model.cover">
                    <div slot="error" class="image-slot">
                      <img src="../../assets/images/default-zb.png" />
                    </div>
                  </el-image>
                </div>
              </div>
              <div class="right">
                <h2>{{ model.title }}</h2>
                <div class="con2">
                  <div class="item">
                    <span class="txt">开播时间：</span>
                    {{ model.start_time }}
                  </div>
                  <div class="item">
                    <span class="txt">直播时长：</span>
                    {{ model.duration }}分钟
                  </div>
                </div>
                <div class="con" v-html="model.description"></div>
              </div>
              <div
                class="operate"
                style="margin-top:20px; width:100%; border-top:none;"
              >
                <a
                  href="javascript:;"
                  class="uc-btn black"
                  style="margin-right:20px;"
                  @click="startLive"
                  v-if="model.is_anchor == 1"
                >
                  开启直播 <i class="uc-font uc-next"></i>
                </a>
                <a
                  href="javascript:;"
                  class="uc-btn black"
                  style="margin-right:20px;"
                  @click="watchLive"
                  v-if="model.is_anchor == 0 && model.status == 1"
                >
                  进入直播 <i class="uc-font uc-next"></i>
                </a>
                <a
                  href="javascript:;"
                  class="uc-btn black"
                  style="margin-right:20px;"
                  @click="watchLive"
                  v-if="model.status == 5"
                >
                  直播回放 <i class="uc-font uc-next"></i>
                </a>
                <div v-if="model.is_subscribe">
                  <a
                    href="javascript:;"
                    class="uc-btn black"
                    style="margin-right:20px;"
                    @click="handleSubClick"
                    v-if="!model.sub_status"
                  >
                    预约直播 <i class="uc-font uc-next"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="uc-btn gray"
                    style="margin-right:20px;"
                    v-else
                  >
                    已预约
                  </a>
                </div>
                <div v-if="model.qst_id > 0">
                  <a
                    href="javascript:;"
                    class="uc-btn black"
                    style="margin-right:20px;"
                    @click="handleQstClick"
                    v-if="!model.qst_status"
                  >
                    调查问卷 <i class="uc-font uc-next"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="uc-btn gray"
                    style="margin-right:20px;"
                    v-else
                  >
                    问卷已作答
                  </a>
                </div>
              </div>
            </section>
          </div>

          <div class="col-24 col-sm-7">
            <section class="uc-ResourcesAuthor ">
              <h2>关于主播</h2>
              <div class="box">
                <div class="author">
                  <div class="face-box">
                    <img
                      :src="model.anchor_avatar"
                      :alt="model.anchor_name"
                      onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                    />
                  </div>
                  <div class="name">{{ model.anchor_name }}</div>
                </div>
                <img src="../../assets/images/bg81.png" class="line" />
                <div class="right">
                  <p>直播数量</p>
                  <div class="number">{{ model.live_count }}</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <!-- <section
      class="container-fluid uc-bg2 uc-pb40"
      v-if="model.is_anchor == 0 || (model.is_anchor == 1 && model.status == 5)"
    >
      <div class="container">
        <div class="row">
          <div class="col-24">
            <iframe
              allow="camera *;microphone *;"
              :src="livePlayUrl"
              width="100%"
              height="600"
              frameborder="0"
              allowfullscreen="true"
              border="0"
            ></iframe>
          </div>
        </div>
      </div>
    </section> -->

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'LiveDetails',
  components: {
    TopHeader,
    BottomFooter,
  },
  data: (vm) => ({
    query: {
      id: vm.$route.params.id,
      from: vm.$route.query.from,
      fromId: vm.$route.query.fromId,
    },
    model: {},
    livePlayUrl: '',
  }),
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getLiveDetails();
    },
    async getLiveDetails() {
      const response = await this.$api.live.getLiveDetails(this.query);
      this.model = response.data.data;
      // 直播观看地址
      this.livePlayUrl = this.model.play_url;
    },
    async startLive() {
      const response = await this.$api.live.startLive(this.query);
      window.open(response.data.data.push_url);
    },
    watchLive() {
      window.open(this.model.play_url);
    },
    // 预约
    handleSubClick() {
      this.$confirm(`确定要预约此直播吗？`, '提示', {
        type: 'info',
      }).then(() => {
        this.$api.live
          .subLive(this.query)
          .then((response) => {
            const { code, message, data } = response.data;
            if (code === 200) {
              this.model.sub_status = 1;
              this.$message.success(message);
            } else {
              this.$message.warning(message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    // 问卷
    handleQstClick() {
      this.$confirm(`确定要参加此问卷吗？`, '提示', {
        type: 'info',
      }).then(() => {
        window.open(
          `/questionnaire/answer/${this.model.qst_id}?from=liveactivity&fromId=${this.query.id}`,
          'QstAnswer'
        );
      });
    },
  },
};
</script>
